import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const AddNewDocument = async (documentDet) => {
    //console.log("document det here", documentDet)
    //debugger;
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Document/AddNewDocument`, 
        documentDet
        )).then(response => response);
    return result;
}

export const AddMultipleDocuments = async (documentDet) => {
    //debugger;
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Document/AddMultipleDocuments`, 
        documentDet
        )).then(response => response);
    return result;
}   

export const GetAllDocumentTypes = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetAllDocumentTypes`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetAllPartnerTypes = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetAllPartnerTypes`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const InsertNewDocumentDet = async (documentDet) => {
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Document/InsertNewDocumentDet`, 
        JSON.stringify(documentDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const GetImportantDocumentByPartnerCode = async(partner_code) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetImportantDocumentByPartnerCode?partner_code=${partner_code}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetGeneralDocumentList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetGeneralDocumentList`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetAllDocumentCategory = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetAllDocumentCategory`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetActiveDocumentListBy_DocumentCategoryId = async(document_category_id) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetActiveDocumentListBy_DocumentCategoryId?document_category_id=${document_category_id}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetActiveDocumentList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Document/GetActiveDocumentList`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}